const viewMoreProductModal = `
    <tpt-clickncollect class="tpt-cnc__viewmore" data-target="tpt-clickncollect-modal" data-location-name="__LOCATION_NAME__" data-location-id="__LOCATION_ID__">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M15 21V16C15 15.7348 14.8946 15.4804 14.7071 15.2929C14.5195 15.1054 14.2652 15 14 15H9.99995C9.73474 15 9.48038 15.1054 9.29285 15.2929C9.10531 15.4804 8.99995 15.7348 8.99995 16V21M17.774 10.31C17.5655 10.1104 17.288 9.99904 16.9995 9.99904C16.7109 9.99904 16.4334 10.1104 16.225 10.31C15.76 10.7535 15.142 11.001 14.4995 11.001C13.8569 11.001 13.2389 10.7535 12.774 10.31C12.5655 10.1107 12.2883 9.99952 12 9.99952C11.7116 9.99952 11.4344 10.1107 11.226 10.31C10.7609 10.7538 10.1428 11.0014 9.49995 11.0014C8.85712 11.0014 8.23899 10.7538 7.77395 10.31C7.56549 10.1104 7.28804 9.99904 6.99945 9.99904C6.71087 9.99904 6.43342 10.1104 6.22495 10.31C5.7758 10.7386 5.18323 10.9848 4.56258 11.0005C3.94193 11.0163 3.33762 10.8006 2.86726 10.3954C2.3969 9.99015 2.09415 9.42439 2.01794 8.80824C1.94173 8.19209 2.0975 7.56962 2.45495 7.062L5.34395 2.878C5.52726 2.60751 5.77405 2.38605 6.06273 2.233C6.35141 2.07994 6.6732 1.99994 6.99995 2H17C17.3257 1.99988 17.6466 2.07934 17.9347 2.23149C18.2228 2.38364 18.4694 2.60386 18.653 2.873L21.548 7.065C21.9055 7.57303 22.0611 8.19597 21.9844 8.81244C21.9077 9.42891 21.6042 9.99475 21.1331 10.3997C20.662 10.8046 20.057 11.0197 19.436 11.0029C18.815 10.9861 18.2225 10.7388 17.774 10.309" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M4 10.9502V19.0002C4 19.5306 4.21071 20.0393 4.58579 20.4144C4.96086 20.7895 5.46957 21.0002 6 21.0002H18C18.5304 21.0002 19.0391 20.7895 19.4142 20.4144C19.7893 20.0393 20 19.5306 20 19.0002V10.9502" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>

        ${window.tptCnc.viewMoreProduct}

        <svg width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_132_3789)">
            <path d="M3.15002 0.450195L2.52002 1.1252L5.85002 4.5002L2.52002 7.87519L3.15002 8.55019L7.20002 4.5002L3.15002 0.450195Z" fill="black"/>
            </g>
            <defs>
            <clipPath id="clip0_132_3789">
            <rect width="9" height="9" fill="white"/>
            </clipPath>
            </defs>
        </svg>
    </tpt-clickncollect>
`;

const viewMoreProductLink = `
    <div class="tpt-cnc__viewmore">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M15 21V16C15 15.7348 14.8946 15.4804 14.7071 15.2929C14.5195 15.1054 14.2652 15 14 15H9.99995C9.73474 15 9.48038 15.1054 9.29285 15.2929C9.10531 15.4804 8.99995 15.7348 8.99995 16V21M17.774 10.31C17.5655 10.1104 17.288 9.99904 16.9995 9.99904C16.7109 9.99904 16.4334 10.1104 16.225 10.31C15.76 10.7535 15.142 11.001 14.4995 11.001C13.8569 11.001 13.2389 10.7535 12.774 10.31C12.5655 10.1107 12.2883 9.99952 12 9.99952C11.7116 9.99952 11.4344 10.1107 11.226 10.31C10.7609 10.7538 10.1428 11.0014 9.49995 11.0014C8.85712 11.0014 8.23899 10.7538 7.77395 10.31C7.56549 10.1104 7.28804 9.99904 6.99945 9.99904C6.71087 9.99904 6.43342 10.1104 6.22495 10.31C5.7758 10.7386 5.18323 10.9848 4.56258 11.0005C3.94193 11.0163 3.33762 10.8006 2.86726 10.3954C2.3969 9.99015 2.09415 9.42439 2.01794 8.80824C1.94173 8.19209 2.0975 7.56962 2.45495 7.062L5.34395 2.878C5.52726 2.60751 5.77405 2.38605 6.06273 2.233C6.35141 2.07994 6.6732 1.99994 6.99995 2H17C17.3257 1.99988 17.6466 2.07934 17.9347 2.23149C18.2228 2.38364 18.4694 2.60386 18.653 2.873L21.548 7.065C21.9055 7.57303 22.0611 8.19597 21.9844 8.81244C21.9077 9.42891 21.6042 9.99475 21.1331 10.3997C20.662 10.8046 20.057 11.0197 19.436 11.0029C18.815 10.9861 18.2225 10.7388 17.774 10.309" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M4 10.9502V19.0002C4 19.5306 4.21071 20.0393 4.58579 20.4144C4.96086 20.7895 5.46957 21.0002 6 21.0002H18C18.5304 21.0002 19.0391 20.7895 19.4142 20.4144C19.7893 20.0393 20 19.5306 20 19.0002V10.9502" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>

        ${window.tptCnc.viewMoreProductLink}

        <svg width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_132_3789)">
            <path d="M3.15002 0.450195L2.52002 1.1252L5.85002 4.5002L2.52002 7.87519L3.15002 8.55019L7.20002 4.5002L3.15002 0.450195Z" fill="black"/>
            </g>
            <defs>
            <clipPath id="clip0_132_3789">
            <rect width="9" height="9" fill="white"/>
            </clipPath>
            </defs>
        </svg>
    </div>
`;

/**
 * Update data
 */

function updateData(locationID, locationName) {
	var viewMoreHtml = '';

	if (window.tptCnc.viewMoreAction == 'link') {
		const collectionUrl = `${window.tptCnc.collectionRoutes}/${window.tptCnc.collectionHandle}?cua_hang=${locationName}&pf_vli_cua_hang_ibsl=true`;
		var viewMoreHtml = viewMoreProductLink.replaceAll('__LOCATION_NAME__', locationName).replace('__VIEWMORE_LINK__', collectionUrl);
	} else {
		var viewMoreHtml = viewMoreProductModal.replaceAll('__LOCATION_NAME__', locationName).replaceAll('__LOCATION_ID__', locationID);
	}

	const cncContainer = document.querySelector('click-and-collect .cc__box');
	const cncViewMoreElement = document.querySelector('click-and-collect .tpt-cnc__viewmore');

	if (cncContainer) {
		if (cncViewMoreElement) {
			cncViewMoreElement.remove();
		}

		cncContainer.insertAdjacentHTML('beforeend', viewMoreHtml);
	}
}

/**
 * Check and update data
 */

document.addEventListener('DOMContentLoaded', () => {
	let input = null;
	let previousValue = '';

	setInterval(() => {
		const cncMethod = document.querySelector('.product-single__meta click-and-collect #deliveryMethod');
		const viewMoreStore = document.querySelector('.product-single__meta tpt-clickncollect');

		if (!cncMethod) {
			return;
		}

		if (cncMethod.value == 'Pickup In Store') {
			if (!input) {
				input = document.getElementById('locationID');
				if (!input) return;

				previousValue = input.getAttribute('data-backup-value');
				return;
			}

			if (input.getAttribute('data-backup-value') !== previousValue) {
				previousValue = input.getAttribute('data-backup-value');

				var locationID = input.getAttribute('data-backup-value');
				var locationName = document.getElementById('locationName').value;

				updateData(locationID, locationName);
			}

			if (viewMoreStore) {
				viewMoreStore.classList.add('tpt-cnc__viewmore--show');
			}
		} else {
			if (viewMoreStore) {
				viewMoreStore.classList.remove('tpt-cnc__viewmore--show');
			}
		}
	}, 100);
});

const fieldsets = document.querySelectorAll('.variant-wrapper .variant-input-wrap');

if (fieldsets) {
	fieldsets.forEach((fieldset) => {
		fieldset.addEventListener('change', (event) => {
			const cncViewMore = document.querySelector('.product-single__meta .tpt-cnc__viewmore');
			const input = event.target;

			if (!input.matches('input[type="radio"][data-variant-input]')) return;

			if (cncViewMore) {
				cncViewMore.remove();
			}

			console.log('Option changed');
			console.log('Value:', input.value);
			console.log('Index:', input.dataset.index);
			console.log('Checked:', input.checked);

			// xử lý của bạn ở đây
		});
	});
}

/**
 * Boost modal products
 */

class BoostModalService {
	static API = 'https://services.mybcapps.com/bc-sf-filter/filter';
	static COLLECTION_SCOPE = window.tptCnc.collectionId;
	static COLLECTION_HANDLE = window.tptCnc.collectionHandle;
	static FILTER_TAGS = window.tptCnc.filterByTags;

	constructor() {
		this.location = '';
		this.limit = window.tptCnc.modalProductLimit;
		this.sort = 'manual';
		this.page = 1;
		this.isLoadingMore = false;
		this.hasNextPage = true;
		this._isInfiniteScrollBound = false;
		this.swatches = window.boostPFSConfig?.swatch_settings || {};

		this.filterTags = (BoostModalService.FILTER_TAGS || '')
			.split(',')
			.map((item) => {
				const [label, value] = item.split('___');

				return {
					label: (label || '').trim(),
					value: (value || label || '').trim(),
				};
			})
			.filter((item) => item.value);

		this.selectedFilters = {};

		this.productCardSimpleTags = (window.tptCnc.productCardCheckboxByTags || '')
			.split(',')
			.map((tag) => tag.trim())
			.filter(Boolean);

		this.data = {
			products: [],
			filters: [],
			totalProducts: 0,
			raw: null,
		};

		this._requestId = 0;

		this._isFilterEventsBound = false;
		this.onFilterChange = this.onFilterChange.bind(this);
		this.closeDropdown = this.closeDropdown.bind(this);
	}

	getSwatchData(value) {
		return this.swatches[value.trim().toLowerCase()] || null;
	}

	// sortFilterValues(filter) {
	// 	if (!filter?.sortType || !Array.isArray(filter.values)) {
	// 		return filter.values || [];
	// 	}

	// 	if (!['key-asc', 'key-desc'].includes(filter.sortType)) {
	// 		return filter.values;
	// 	}

	// 	const direction = filter.sortType === 'key-desc' ? -1 : 1;

	// 	const parse = (key) => {
	// 		key = key.trim();

	// 		// 1 Pcs / 5 Pcs
	// 		let m = key.match(/^(\d+)\s+Pcs$/i);
	// 		if (m) {
	// 			return {
	// 				group: 0,
	// 				values: [Number(m[1])],
	// 			};
	// 		}

	// 		// US C6
	// 		m = key.match(/^US\s+C(\d+)$/i);
	// 		if (m) {
	// 			return {
	// 				group: 1,
	// 				values: [Number(m[1])],
	// 			};
	// 		}

	// 		// US J2
	// 		m = key.match(/^US\s+J(\d+)$/i);
	// 		if (m) {
	// 			return {
	// 				group: 2,
	// 				values: [Number(m[1])],
	// 			};
	// 		}

	// 		// US M7
	// 		m = key.match(/^US\s+M(\d+)$/i);
	// 		if (m) {
	// 			return {
	// 				group: 3,
	// 				// không có hậu tố -> đứng trước
	// 				values: [Number(m[1]), 0, 0],
	// 			};
	// 		}

	// 		// US M7W9
	// 		m = key.match(/^US\s+M(\d+)W(\d+)$/i);
	// 		if (m) {
	// 			return {
	// 				group: 3,
	// 				// có hậu tố -> đứng sau cùng số M
	// 				values: [Number(m[1]), 1, Number(m[2])],
	// 			};
	// 		}

	// 		// US W6
	// 		m = key.match(/^US\s+W(\d+)$/i);
	// 		if (m) {
	// 			return {
	// 				group: 4,
	// 				values: [Number(m[1])],
	// 			};
	// 		}

	// 		return {
	// 			group: 99,
	// 			values: [key.toLowerCase()],
	// 		};
	// 	};

	// 	return [...filter.values].sort((a, b) => {
	// 		const pa = parse(a.key);
	// 		const pb = parse(b.key);

	// 		if (pa.group !== pb.group) {
	// 			return (pa.group - pb.group) * direction;
	// 		}

	// 		const len = Math.max(pa.values.length, pb.values.length);

	// 		for (let i = 0; i < len; i++) {
	// 			const va = pa.values[i] ?? 0;
	// 			const vb = pb.values[i] ?? 0;

	// 			if (va === vb) continue;

	// 			if (typeof va === 'string') {
	// 				return va.localeCompare(vb) * direction;
	// 			}

	// 			return (va - vb) * direction;
	// 		}

	// 		return 0;
	// 	});
	// }

	/* Fix lỗi sort theo price value */
	

	sortFilterValues(filter) {
		if (!filter?.sortType || !Array.isArray(filter.values)) {
			return filter?.values || [];
		}

		if (!['key-asc', 'key-desc'].includes(filter.sortType)) {
			return filter.values;
		}

		const direction = filter.sortType === 'key-desc' ? -1 : 1;

		const formatPrice = (value) => {
			return Number(value).toLocaleString('vi-VN') + 'đ';
		};

		const formatPriceLabel = (key) => {
			key = String(key || '').trim();

			// Dưới 500.000đ
			let m = key.match(/^\*-(\d+)$/);

			if (m) {
				return `${window.tptCnc.under} ${formatPrice(m[1])}`;
			}

			// 500.000đ - 1.000.000đ
			m = key.match(/^(\d+)-(\d+)$/);

			if (m) {
				return `${formatPrice(m[1])} - ${formatPrice(m[2])}`;
			}

			// Trên 2.000.000đ
			m = key.match(/^(\d+)-\*$/);

			if (m) {
				return `${window.tptCnc.above} ${formatPrice(m[1])}`;
			}

			return key;
		};

		const parse = (key) => {
			key = String(key || '').trim();

			// ==============================
			// PRICE
			// ==============================
			if (filter.filterType === 'price') {
				// *-500000
				let m = key.match(/^\*-(\d+)$/);

				if (m) {
					return {
						group: 0,
						values: [0, Number(m[1]), 0],
					};
				}

				// 500000-1000000
				m = key.match(/^(\d+)-(\d+)$/);

				if (m) {
					return {
						group: 0,
						values: [Number(m[1]), Number(m[2]), 1],
					};
				}

				// 2000000-*
				m = key.match(/^(\d+)-\*$/);

				if (m) {
					return {
						group: 0,
						values: [Number(m[1]), Infinity, 2],
					};
				}

				return {
					group: 99,
					values: [key.toLowerCase()],
				};
			}

			// ==============================
			// 1 Pcs / 5 Pcs
			// ==============================
			let m = key.match(/^(\d+)\s+Pcs$/i);

			if (m) {
				return {
					group: 0,
					values: [Number(m[1])],
				};
			}

			// ==============================
			// US C6
			// ==============================
			m = key.match(/^US\s+C(\d+)$/i);

			if (m) {
				return {
					group: 1,
					values: [Number(m[1])],
				};
			}

			// ==============================
			// US J1
			// ==============================
			m = key.match(/^US\s+J(\d+)$/i);

			if (m) {
				return {
					group: 2,
					values: [Number(m[1])],
				};
			}

			// ==============================
			// US M7
			// ==============================
			m = key.match(/^US\s+M(\d+)$/i);

			if (m) {
				return {
					group: 3,
					values: [Number(m[1]), 0, 0],
				};
			}

			// ==============================
			// US M7W9
			// ==============================
			m = key.match(/^US\s+M(\d+)W(\d+)$/i);

			if (m) {
				return {
					group: 3,
					values: [Number(m[1]), 1, Number(m[2])],
				};
			}

			// ==============================
			// US W5
			// ==============================
			m = key.match(/^US\s+W(\d+)$/i);

			if (m) {
				return {
					group: 4,
					values: [Number(m[1])],
				};
			}

			// ==============================
			// Fallback
			// ==============================
			return {
				group: 99,
				values: [key.toLowerCase()],
			};
		};

		return [...filter.values]
			.sort((a, b) => {
				const pa = parse(a.key);
				const pb = parse(b.key);

				if (pa.group !== pb.group) {
					return (pa.group - pb.group) * direction;
				}

				const len = Math.max(pa.values.length, pb.values.length);

				for (let i = 0; i < len; i++) {
					const va = pa.values[i] ?? 0;
					const vb = pb.values[i] ?? 0;

					if (va === vb) continue;

					if (typeof va === 'string' || typeof vb === 'string') {
						return String(va).localeCompare(String(vb)) * direction;
					}

					return (va - vb) * direction;
				}

				return 0;
			})
			.map((item) => {
				// Chỉ thay label hiển thị cho Price.
				// item.key vẫn được giữ nguyên để làm value/API filter.
				if (filter.filterType === 'price') {
					return {
						...item,
						label: formatPriceLabel(item.key),
					};
				}

				return item;
			});
	}

	closeDropdown() {
		document.querySelectorAll('.tpt-cnc-dropdown.open').forEach((dropdown) => {
			dropdown.classList.remove('open');
		});
	}

	async load() {
		const requestId = ++this._requestId;

		const response = await this.#request();

		if (requestId !== this._requestId) {
			return this.data;
		}

		const products = response.products || [];
		const totalProducts = response.total_product || 0;

		this.hasNextPage = this.page * this.limit < totalProducts;

		this.data = {
			products,
			filters: response.filter || response.filter_tree || [],
			totalProducts,
			raw: response,
		};

		return this.data;
	}

	async setLocation(locationName, locationId) {
		this.location = locationName;
		this.locationName = locationName;
		this.locationId = locationId;

		this.selectedFilters = {};
		this.page = 1;
		this.hasNextPage = true;

		return this.load();
	}

	async setSort(sort) {
		this.sort = sort;
		return this.load();
	}

	async applyDefaultFilter(filterOptions = []) {
		const filters = [...filterOptions]
			.filter((filter) => filter.filterType !== 'location')
			.sort((a, b) => {
				if (a.filterType === 'product_type') return -1;
				if (b.filterType === 'product_type') return 1;

				return a.position - b.position;
			});

		if (this.filterTags.length) {
			if (this.selectedFilters.tag?.length) {
				return this.data;
			}

			this.selectedFilters = {
				...this.selectedFilters,
				tag: [this.filterTags[0].value],
			};

			return this.load();
		}

		const defaultFilter = filters.find((filter) => filter.filterType === 'product_type' && filter.values?.length > 0) || filters.find((filter) => filter.values?.length > 0);

		if (!defaultFilter) {
			return this.data;
		}

		const defaultValue = defaultFilter.values?.[0];

		if (!defaultValue) {
			return this.data;
		}

		if (this.selectedFilters[defaultFilter.filterOptionId]?.length) {
			return this.data;
		}

		this.selectedFilters = {
			...this.selectedFilters,
			[defaultFilter.filterOptionId]: [defaultValue.key],
		};

		return this.load();
	}

	renderFilters(filterOptions = []) {
		const container = document.getElementById('tpt-cnc__filters');

		if (!container) return;

		container.innerHTML = `
			<div class="el-cnc-filter__wrapper">
				<div class="el-cnc-filter__by-tag"></div>
				<div class="el-cnc-filter__other"></div>
			</div>

			<div class="tpt-cnc-dropdown-layer"></div>
		`;

		const tagContainer = container.querySelector('.el-cnc-filter__by-tag');
		const otherContainer = container.querySelector('.el-cnc-filter__other');
		const dropdownLayer = container.querySelector('.tpt-cnc-dropdown-layer');

		if (this.filterTags.length) {
			this.filterTags.forEach((tag) => {
				const wrapper = document.createElement('div');

				wrapper.className = 'tpt-cnc-filter';
				wrapper.dataset.filterId = 'tag';

				const label = document.createElement('label');
				label.className = 'tpt-cnc-filter__checkbox';

				const input = document.createElement('input');

				input.type = 'checkbox';
				input.name = 'tag';
				input.value = tag.value;

				input.checked = this.selectedFilters.tag?.includes(tag.value) || false;

				const text = document.createElement('span');

				text.textContent = tag.label;

				label.append(input, text);

				wrapper.append(label);

				tagContainer.append(wrapper);
			});
		}

		const filters = [...filterOptions]
			.filter((f) => f.filterType !== 'location')
			.sort((a, b) => {
				if (a.filterType === 'product_type') return -1;
				if (b.filterType === 'product_type') return 1;
				return a.position - b.position;
			});

		filters.forEach((filter) => {
			const wrapper = document.createElement('div');

			wrapper.className = 'tpt-cnc-filter';

			wrapper.dataset.filterId = filter.filterOptionId;

			if (filter.selectType === 'multiple' && filter.filterType !== 'product_type') {
				const group = document.createElement('div');

				group.className = 'tpt-cnc-filter__checkbox-group';

				filter.values.forEach((item) => {
					const label = document.createElement('label');

					label.className = 'tpt-cnc-filter__checkbox';

					label.innerHTML = `
					<input
						type="checkbox"
						name="${filter.filterOptionId}"
						value="${item.key}"
						${this.selectedFilters[filter.filterOptionId]?.includes(item.key) ? 'checked' : ''}>
					<span>${item.key} (${item.doc_count})</span>
				`;

					group.append(label);
				});

				wrapper.innerHTML = `
				<div class="tpt-cnc-filter__title">
					${filter.label}
				</div>
			`;

				wrapper.append(group);
			} else {
				wrapper.append(
					this.renderDropdown({
						name: filter.filterOptionId,
						label: filter.label,
						values: this.sortFilterValues(filter),
						selected: this.selectedFilters[filter.filterOptionId]?.[0] || '',
						isPrice: filter.filterType === 'price',
						layer: dropdownLayer,
					}),
				);
			}

			otherContainer.append(wrapper);
		});

		otherContainer.insertAdjacentHTML(
			'afterbegin',
			`
					<div class="tpt-cnc-filter__actions">
						<button
							type="button"
							class="tpt-cnc-filter__clear-all">
							${window.tptCnc.clearAll}
						</button>
					</div>
				`,
		);

		this.initDropdowns();
	}

	renderDropdown({ name, label, values = [], selected = '', isPrice = false, layer }) {
		const dropdown = document.createElement('div');

		dropdown.className = 'tpt-cnc-dropdown';
		dropdown.dataset.filterId = name;

		dropdown.innerHTML = `
			<button
				type="button"
				class="tpt-cnc-dropdown__button">
				<span class="tpt-cnc-dropdown__text">${label}</span>
				<span class="tpt-cnc-dropdown__icon"></span>
			</button>

			<input
				type="hidden"
				name="${name}"
				value="${selected}">

			<select class="tpt-cnc-dropdown__native">
				<option value="">${label}</option>
			</select>
		`;

		const button = dropdown.querySelector('.tpt-cnc-dropdown__button');
		const buttonText = dropdown.querySelector('.tpt-cnc-dropdown__text');
		const input = dropdown.querySelector('input[type=hidden]');
		const select = dropdown.querySelector('select');

		// ===== Native select =====

		values.forEach((item) => {
			let value = item.key;

			if (isPrice) {
				value = value.replace('*-', ':').replace('-*', ':').replace('-', ':');
			}

			const option = document.createElement('option');

			option.value = value;
			option.textContent = item.label || `${item.key} (${item.doc_count})`;
			option.disabled = item.doc_count === 0;
			option.selected = String(value) === String(selected);

			select.append(option);
		});

		// ===== Floating menu =====

		const menu = document.createElement('div');

		menu.className = 'tpt-cnc-dropdown__menu';

		layer.append(menu);

		const createItem = ({ value, text, disabled = false, swatch = null }) => {
			const item = document.createElement('button');

			item.type = 'button';
			item.className = 'tpt-cnc-dropdown__item';

			item.dataset.value = value;
			item.dataset.label = text;

			item.disabled = disabled;
			//item.textContent = text;

			if (swatch) {
				const swatchHtml =
					swatch.type === 'image'
						? `
							<span
								class="tpt-cnc-dropdown__swatch"
								style="background-image:url('${swatch.imageUrl}')">
							</span>
						`
						: `
							<span
								class="tpt-cnc-dropdown__swatch"
								style="background:${swatch.colorCodes[0]}">
							</span>
						`;

				item.innerHTML = `
					${swatchHtml}
					<span>${text}</span>
				`;
			} else {
				item.textContent = text;
			}

			if (String(value) === String(selected)) {
				item.classList.add('is-selected');
				item.setAttribute('aria-selected', 'true');
			}

			menu.append(item);
		};

		createItem({
			value: '',
			text: label,
		});

		values.forEach((item) => {
			let value = item.key;

			if (isPrice) {
				value = value.replace('*-', ':').replace('-*', ':').replace('-', ':');
			}

			const swatch = this.getSwatchData(item.key);

			createItem({
				value,
				text: item.label || item.key,
				disabled: item.doc_count === 0,
				swatch,
			});
		});

		// ===== Restore selected state =====

		const selectedOption = menu.querySelector(`.tpt-cnc-dropdown__item[data-value="${CSS.escape(selected)}"]`) || menu.querySelector('.tpt-cnc-dropdown__item');

		buttonText.textContent = selectedOption.dataset.label;

		button.classList.toggle('has-value', selected !== '');

		select.value = selected;
		input.value = selected;

		dropdown._menu = menu;
		dropdown._select = select;
		dropdown._input = input;

		return dropdown;
	}

	initDropdowns() {
		document.querySelectorAll('.tpt-cnc-dropdown').forEach((dropdown) => {
			const button = dropdown.querySelector('.tpt-cnc-dropdown__button');
			const input = dropdown._input;
			const select = dropdown._select;
			const menu = dropdown._menu;

			if (!button || !menu || !input || !select) return;

			// ===== Restore state =====
			const currentValue = input.value;

			const currentItem = menu.querySelector(`.tpt-cnc-dropdown__item[data-value="${CSS.escape(currentValue)}"]`);

			if (currentItem) {
				menu.querySelectorAll('.tpt-cnc-dropdown__item').forEach((item) => {
					item.classList.remove('is-selected');
					item.setAttribute('aria-selected', 'false');
				});

				currentItem.classList.add('is-selected');
				currentItem.setAttribute('aria-selected', 'true');

				button.querySelector('.tpt-cnc-dropdown__text').textContent = currentItem.dataset.label;
			} else {
				button.querySelector('.tpt-cnc-dropdown__text').textContent = select.options[0]?.textContent || '';
			}

			button.classList.toggle('has-value', currentValue !== '');
			select.value = currentValue;

			// Remove event cũ (nếu render lại nhiều lần)

			if (button._clickHandler) {
				button.removeEventListener('click', button._clickHandler);
			}

			if (menu._clickHandler) {
				menu.removeEventListener('click', menu._clickHandler);
			}

			if (select._changeHandler) {
				select.removeEventListener('change', select._changeHandler);
			}

			// Open menu

			button._clickHandler = (e) => {
				e.stopPropagation();

				document.querySelectorAll('.tpt-cnc-dropdown__menu.open').forEach((m) => {
					if (m !== menu) {
						m.classList.remove('open');
					}
				});

				const rect = button.getBoundingClientRect();

				menu.style.position = 'fixed';
				menu.style.left = `${rect.left}px`;
				menu.style.top = `${rect.bottom + 6}px`;
				menu.style.minWidth = `${rect.width}px`;
				menu.style.zIndex = '9999';

				menu.classList.toggle('open');
			};

			button.addEventListener('click', button._clickHandler);

			// Click on menu item

			menu._clickHandler = (e) => {
				e.stopPropagation();

				const option = e.target.closest('.tpt-cnc-dropdown__item');

				if (!option || option.disabled) return;

				menu.querySelectorAll('.tpt-cnc-dropdown__item').forEach((item) => {
					item.classList.remove('is-selected');
					item.setAttribute('aria-selected', 'false');
				});

				option.classList.add('is-selected');
				option.setAttribute('aria-selected', 'true');

				input.value = option.dataset.value;
				select.value = option.dataset.value;

				button.querySelector('.tpt-cnc-dropdown__text').textContent = option.dataset.label;
				button.classList.toggle('has-value', option.dataset.value !== '');

				menu.classList.remove('open');

				input.dispatchEvent(
					new Event('change', {
						bubbles: true,
					}),
				);
			};

			menu.addEventListener('click', menu._clickHandler);

			// Mobile select change

			select._changeHandler = () => {
				input.value = select.value;

				const option = select.selectedOptions[0];

				button.querySelector('.tpt-cnc-dropdown__text').textContent = option.textContent;
				button.classList.toggle('has-value', select.value !== '');

				menu.querySelectorAll('.tpt-cnc-dropdown__item').forEach((item) => {
					const active = item.dataset.value === select.value;

					item.classList.toggle('is-selected', active);
					item.setAttribute('aria-selected', active);
				});

				input.dispatchEvent(
					new Event('change', {
						bubbles: true,
					}),
				);
			};

			select.addEventListener('change', select._changeHandler);
		});

		// Click outside to close dropdowns

		document.removeEventListener('click', this.closeDropdown);

		this.closeDropdown = () => {
			document.querySelectorAll('.tpt-cnc-dropdown__menu.open').forEach((menu) => {
				menu.classList.remove('open');
			});
		};

		document.addEventListener('click', this.closeDropdown);

		// Scroll wrapper

		const wrapper = document.querySelector('.el-cnc-filter__wrapper');

		if (wrapper && !this._dropdownScrollBound) {
			this._dropdownScrollBound = true;

			wrapper.addEventListener('scroll', () => {
				this.closeDropdown();
			});
		}

		// Window scroll

		const modalBody = document.querySelector('#tpt-clickncollect-modal tpt-modal-body');

		if (modalBody && !this._modalScrollBound) {
			this._modalScrollBound = true;

			modalBody.addEventListener('scroll', () => {
				this.closeDropdown();
			});
		}

		if (!this._dropdownResizeBound) {
			this._dropdownResizeBound = true;

			window.addEventListener('resize', this.closeDropdown);
		}
	}

	getSelectedFilters() {
		const container = document.getElementById('tpt-cnc__filters');

		if (!container) return {};

		const filters = {};

		if (this.location) {
			filters.pf_vl_cua_hang = this.location;
		}

		container.querySelectorAll('input[type="checkbox"]:checked').forEach((input) => {
			const key = input.name;

			if (!filters[key]) {
				filters[key] = [];
			}

			filters[key].push(input.value);
		});

		container.querySelectorAll('.tpt-cnc-dropdown input[type="hidden"]').forEach((input) => {
			if (!input.value) return;

			filters[input.name] = input.value;
		});

		return filters;
	}

	async onClearAllFilters() {
		const data = await this.clearFilters();

		this.renderFilters(data.filters.options);

		this.renderProductHtml(data.products, false);

		this.bindAddCartEvents();
	}

	bindFilterEvents() {
		const container = document.getElementById('tpt-cnc__filters');

		if (!container || this._isFilterEventsBound) return;

		container.addEventListener('click', (event) => {
			const button = event.target.closest('.tpt-cnc-filter__clear-all');

			if (!button) return;

			this.onClearAllFilters();
		});

		this._isFilterEventsBound = true;

		container.addEventListener('change', (event) => {
			const target = event.target;

			if (target.matches('input[type="checkbox"]')) {
				this.onFilterChange(event);
				return;
			}

			if (target.matches('.tpt-cnc-dropdown input[type="hidden"]')) {
				this.onFilterChange(event);
				return;
			}
		});
	}

	bindAddCartEvents() {
		console.count('bindAddCartEvents');

		const productContainer = document.getElementById('tpt-cnc__products');

		if (productContainer && !this._isAddCartEventsBound) {
			this._isAddCartEventsBound = true;

			productContainer.addEventListener('click', (event) => {
				const button = event.target.closest('.tpt-cnc__products-item-add-cart');

				if (!button) return;

				this.addSingleProduct(button);
			});
		}

		// document.querySelector('.tpt-cnc-footer__add-cart-all')?.addEventListener('click', () => {
		// 	console.log('Add all to carrt');
		// 	document.querySelector('.tpt-cnc-footer__add-cart-all').classList.add('adding');
		// 	document.querySelector('.tpt-cnc-footer__add-cart-all').setAttribute('data-text', window.tptCnc.adding);
		// 	this.addCheckedProducts();
		// });

		const btn = document.querySelector('.tpt-cnc-footer__add-cart-all');

		if (btn) {
			btn.onclick = () => {
				btn.classList.add('adding');
				btn.setAttribute('data-text', window.tptCnc.adding);
				this.addCheckedProducts();
			};
		}
	}

	async addSingleProduct(button) {
		const productItem = button.closest('.tpt-cnc__products-item');

		if (!productItem) return;

		const variantSelect = productItem.querySelector('.tpt-cnc__products-item-variant');

		if (!variantSelect) return;

		button.classList.remove('added');
		button.classList.add('adding');

		const item = {
			id: Number(variantSelect.value),
			quantity: 1,
			properties: {
				DeliveryMethod: 'Pickup In Store',
				LocationName: this.locationName,
				LocationID: this.locationId,
				_QuantityAvailable: variantSelect.selectedOptions[0]?.dataset.quantityAvailable || '1',
			},
		};

		try {
			await this.addItems([item]);

			button.classList.remove('adding');
			button.classList.add('added');

			setTimeout(() => {
				button.classList.remove('added');
			}, 2000);
		} catch (e) {
			button.classList.remove('adding');
		}
	}

	async addCheckedProducts() {
		console.count('addCheckedProducts');
		console.log('Add checked all product...');
		const checkedProducts = document.querySelectorAll('.tpt-cnc-add-cart-checkbox:checked');

		if (!checkedProducts.length) return;

		const items = [];

		checkedProducts.forEach((checkbox) => {
			items.push({
				id: Number(checkbox.value),
				quantity: 1,
				properties: {
					DeliveryMethod: 'Pickup In Store',
					LocationName: this.locationName,
					LocationID: this.locationId,
					_QuantityAvailable: checkbox.dataset.quantityAvailable || '1',
				},
			});
		});

		console.log(items);

		await this.addItems(items);
	}

	updateAndShowCartDrawer() {
		new theme.CartDrawer();
		document.querySelector('[aria-controls="CartDrawer"]').click();
	}

	updateMainCart() {
		if (window.tptCnc.isCartPage) {
			var cartPageForm = document.getElementById('CartPageForm');
			if (cartPageForm) {
				var cartForm = new theme.CartForm(cartPageForm);
				cartForm.buildCart();
			}
		}
	}

	async addItems(items = []) {
		if (!items.length) return;

		const buttonAddAll = document.querySelector('.tpt-cnc-footer__add-cart-all');
		const buttonAddSingle = document.querySelector('.tpt-cnc__products-item-add-cart.adding');

		try {
			const response = await fetch('/cart/add.js', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					Accept: 'application/json',
				},
				body: JSON.stringify({ items }),
			});

			if (!response.ok) {
				const error = await response.json();
				throw new Error(error.description || error.message || 'Add cart failed.');
			}

			await response.json();

			const cart = await fetch('/cart.js').then((res) => res.json());

			this.updateAndShowCartDrawer();
			this.updateMainCart();

			if (buttonAddAll) {
				setTimeout(() => {
					buttonAddAll.dataset.text = window.tptCnc.added;
				}, 400);

				setTimeout(() => {
					buttonAddAll.dataset.text = window.tptCnc.addAllToCart;
					buttonAddAll.classList.remove('adding');
				}, 2000);
			}
		} catch (error) {
			console.error(error);

			if (buttonAddAll) {
				buttonAddAll.dataset.text = window.tptCnc.addAllToCart;
				buttonAddAll.classList.remove('adding');
			}

			alert(error.message);

			throw error;
		}
	}

	fetchRenderProducts(productElements = []) {
		productElements.forEach((product) => {
			const fetchUrl = product.dataset.productUrl;

			fetch(fetchUrl)
				.then((res) => res.text())
				.then((html) => {
					const doc = new DOMParser().parseFromString(html, 'text/html');

					product.innerHTML = doc.querySelector('.shopify-section').innerHTML;
				});
		});
	}

	renderProductHtml(products = [], append = false) {
		const container = document.getElementById('tpt-cnc__products');

		if (!container) return;

		const html = products
			.map((product) => {
				const sectionId = product.tags?.some((tag) => this.productCardSimpleTags.includes(tag)) ? 'tpt-cnc-product-item-simple' : 'tpt-cnc-product-item';

				return `
            <div
                class="tpt-cnc__products-item"
                data-product-url="${window.tptCnc.productRoutes}/${product.handle}?section_id=${sectionId}">
                <div class="tpt-cnc__placeholder"></div>
            </div>
        `;
			})
			.join('');

		let newItems;

		if (append) {
			const oldLength = container.children.length;

			container.insertAdjacentHTML('beforeend', html);

			newItems = Array.from(container.children).slice(oldLength);
		} else {
			container.innerHTML = html;

			newItems = container.querySelectorAll('.tpt-cnc__products-item');
		}

		this.fetchRenderProducts(newItems);
	}

	async onFilterChange(event) {
		const target = event.target;

		// All filter

		if (target.matches('input[type="checkbox"]') && target.checked) {
			document.querySelectorAll(`input[name="${target.name}"]`).forEach((input) => {
				if (input !== target) {
					input.checked = false;
				}
			});
		}

		const filters = this.getSelectedFilters();

		const data = await this.setFilter(filters);

		this.renderFilters(data.filters.options);

		console.log('FILTERS:', data.filters);
		console.log('PRODUCTS:', data.products);

		this.renderProductHtml(data.products, false);
		this.bindAddCartEvents();
	}

	async setFilter(filters = {}) {
		this.page = 1;
		this.hasNextPage = true;
		this.isLoadingMore = false;

		this.selectedFilters = {};

		Object.entries(filters).forEach(([key, values]) => {
			if (!Array.isArray(values)) values = [values];

			values = values.filter(Boolean);

			if (values.length) {
				this.selectedFilters[key] = values;
			}
		});

		return this.load();
	}

	async clearFilter(key) {
		delete this.selectedFilters[key];
		return this.load();
	}

	async clearFilters() {
		this.selectedFilters = {};

		// giữ nguyên location
		if (this.location) {
			this.selectedFilters.pf_vl_cua_hang = [this.location];
		}

		this.page = 1;
		this.hasNextPage = true;
		this.isLoadingMore = false;

		return this.load();
	}

	async loadNextPage() {
		if (this.isLoadingMore) return;

		if (!this.hasNextPage) return;

		this.isLoadingMore = true;

		try {
			this.page++;

			const data = await this.load();

			this.renderProductHtml(data.products, true);

			this.bindAddCartEvents();
		} catch (e) {
			this.page--;

			console.error(e);
		} finally {
			this.isLoadingMore = false;
		}
	}

	bindInfiniteScroll() {
		if (this._isInfiniteScrollBound) return;

		this._isInfiniteScrollBound = true;

		const body = document.querySelector('#tpt-clickncollect-modal tpt-modal-body');

		if (!body) return;

		body.addEventListener('scroll', () => {
			if (this.isLoadingMore) return;

			if (!this.hasNextPage) return;

			const distance = body.scrollHeight - body.scrollTop - body.clientHeight;

			if (distance < 300) {
				this.loadNextPage();
			}
		});
	}

	#request() {
		return new Promise((resolve, reject) => {
			const callback = `BoostCallback_${Date.now()}_${Math.random().toString(36).slice(2)}`;

			const params = new URLSearchParams({
				t: Date.now(),
				_: 'pf',
				shop: Shopify.shop,
				page: this.page,
				limit: this.limit,
				sort: this.sort,
				display: 'grid',
				collection_scope: BoostModalService.COLLECTION_SCOPE,
				tag: '',
				product_available: true,
				variant_available: true,
				zero_options: true,
				build_filter_tree: true,
				check_cache: false,
				sort_first: 'available',
				locale: Shopify.locale,
				event_type: 'init',
				inventory_base_selected_locations: true,
				callback,
			});

			if (this.location) {
				params.append('pf_vl_cua_hang[]', this.location);
			}

			Object.entries(this.selectedFilters).forEach(([param, values]) => {
				values.forEach((value) => {
					params.append(`${param}[]`, value);
				});
			});

			const script = document.createElement('script');

			const cleanup = () => {
				delete window[callback];
				script.remove();
			};

			window[callback] = (response) => {
				cleanup();
				resolve(response);
			};

			script.onerror = () => {
				cleanup();
				reject(new Error('Boost request failed.'));
			};

			script.src = `${BoostModalService.API}?${params.toString()}`;

			document.head.appendChild(script);
		});
	}
}

window.boostModal = new BoostModalService();

class TptClicknCollect extends HTMLElement {
	constructor() {
		super();

		this.onClick = this.onClick.bind(this);

		const modalId = this.getAttribute('data-target');
		this.modal = document.getElementById(modalId);
	}

	connectedCallback() {
		this.addEventListener('click', this.onClick);
	}

	disconnectedCallback() {
		this.removeEventListener('click', this.onClick);
	}

	showModal() {
		this.modal.classList.add('show');
	}

	hiddenCartDrawer() {
		document.getElementById('CartDrawer').classList.remove('drawer--is-open');
		document.documentElement.classList.remove('js-drawer-open', 'CartDrawer-cart', 'lock-scroll');
	}

	async onClick(event) {
		event.preventDefault();

		const locationName = this.dataset.locationName;
		const locationId = this.dataset.locationId;
		const viewAllButtonCollection = document.querySelector('.tpt-cnc-footer__view-all');
		const viewAllButtonCollectionUrl = `${window.tptCnc.collectionRoutes}/${window.tptCnc.collectionHandle}?cua_hang=${locationName}`;
		viewAllButtonCollection.setAttribute('href', viewAllButtonCollectionUrl);

		if (!locationName) return;

		try {
			document.querySelector('#tpt-clickncollect-modal .modal-title__title--value').innerHTML = locationName;

			this.classList.add('loading');

			this.hiddenCartDrawer();
			this.showModal();

			let data = await boostModal.setLocation(locationName, locationId);

			// Render lần đầu
			boostModal.renderFilters(data.filters.options);

			// Apply default filter nếu chưa có
			data = await boostModal.applyDefaultFilter(data.filters.options);

			// Render lại theo dữ liệu mới
			boostModal.renderFilters(data.filters.options);

			// Render product sau này
			// boostModal.renderProducts(data.products);

			boostModal.bindFilterEvents(data.products);

			console.log('FILTERS:', data.filters.options);
			console.log('PRODUCTS:', data.products);

			boostModal.renderProductHtml(data.products, false);
			boostModal.bindAddCartEvents();
			boostModal.bindInfiniteScroll();
		} catch (error) {
			console.error(error);

			this.dispatchEvent(
				new CustomEvent('tpt-clickncollect:error', {
					bubbles: true,
					detail: error,
				}),
			);
		} finally {
			this.classList.remove('loading');
		}
	}
}

customElements.define('tpt-clickncollect', TptClicknCollect);

/**
 * Clear filter
 */

class TptClicknCollectClearFilter extends HTMLElement {
	constructor() {
		super();

		this.onClick = this.onClick.bind(this);
	}

	connectedCallback() {
		this.addEventListener('click', this.onClick);
	}

	disconnectedCallback() {
		this.removeEventListener('click', this.onClick);
	}

	async onClick(event) {
		event.preventDefault();

		try {
			this.classList.add('loading');

			// Clear tất cả filter (location vẫn giữ nguyên)
			const data = await boostModal.clearFilters();

			// Render lại filter
			boostModal.renderFilters(data.filters.options);

			// Apply default Product Type nếu có
			const newData = await boostModal.applyDefaultFilter(data.filters.options);

			boostModal.renderFilters(newData.filters.options);
			boostModal.renderProductHtml(newData.products, false);
		} catch (error) {
			console.error(error);
		} finally {
			this.classList.remove('loading');
		}
	}
}

customElements.define('tpt-cnc-clear-filter', TptClicknCollectClearFilter);
